module.exports = __webpack_public_path__ + "img/code.44642912.svg";